<template>
  <div class="inner">

    <!-- 初期表示時の画面 -->
    <div class="l-contents" v-if="showCreate">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav8_blue.svg" alt="">人的資本管理</h1>
      <div class="l-contentsBox">
        <div class="human-capital-welcome">
          <div class="human-capital-welcome__img"><img src="@/assets/img/common/hc-icon01.svg" alt=""></div>
          <p class="human-capital-welcome__catch">ヨクスルの人的資本管理へようこそ</p>
          <p class="l-text">まずは人的資本に関する実績を入力して現状を把握しましょう。</p>
          <div class="btn-basic is-inlne is-primary is-wide mt-30"><a @click="createNewYear">人的資本に関する実績値を入力</a></div>
        </div>
      </div>
    </div>

    <!-- 設定保存の画面(管理ユーザー) -->
    <div class="l-contents" v-if="showSetting && (this.isAdmin || this.isAllPermission) && !isNormal">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav8_blue.svg" alt="">人的資本管理</h1>
      <div class="l-contentsBox">
        <div class="human-capital-welcome">
          <div class="human-capital-welcome__img"><img src="@/assets/img/common/hc-icon01.svg" alt=""></div>
          <p class="human-capital-welcome__catch">ヨクスルの人的資本管理へようこそ</p>
          <div class="human-capital-welcome__body">
            <p class="l-text u-tac is-lg"><strong>人的資本を利用するために必須の情報を入力してください。</strong></p>
            <p class="l-text u-tac">この項目は <a class="l-textlink" @click="goCorp">法人情報 > 企業の特徴</a> からも設定できます。</p>

            <!-- エラー表示 -->
            <div class="l-contentsSection error" 
              v-if="$v.corporateFeatureInfo.accountClosingMonth.$error
              || $v.corporateFeatureInfo.industoryItemId.$error 
              || $v.corporateFeatureInfo.industorySubitemId.$error">
              <div v-if="$v.corporateFeatureInfo.accountClosingMonth.$error" style="padding-bottom:5px;">
                <span style="color:red; font-size: 1.5rem;margin-left: 20px;">決算月　　　　　　　：</span>
                <ValidationErrorMessage style="margin-left:20px;" v-show="$v.corporateFeatureInfo.accountClosingMonth.$error && !$v.corporateFeatureInfo.accountClosingMonth.required" validation="required"/>
              </div>
              <div v-if="$v.corporateFeatureInfo.industoryItemId.$error" style="padding-bottom:5px;">
                <span style="color:red; font-size: 1.5rem;margin-left: 20px;">主たる業種（大項目）：</span>
                <ValidationErrorMessage style="margin-left:20px;" v-show="$v.corporateFeatureInfo.industoryItemId.$error && !$v.corporateFeatureInfo.industoryItemId.required" validation="required"/>
              </div>
              <div v-if="$v.corporateFeatureInfo.industorySubitemId.$error" style="padding-bottom:5px;">
                <span style="color:red; font-size: 1.5rem;margin-left: 20px;">主たる業種（中項目）：</span>
                <ValidationErrorMessage style="margin-left:20px;" v-show="$v.corporateFeatureInfo.industorySubitemId.$error && !$v.corporateFeatureInfo.industorySubitemId.required" validation="required"/>
              </div>
            </div>

            <table class="l-form-table u-mt30">
              <tbody>
                <tr>
                  <th><span>決算月</span></th>
                  <td>
                    <div class="l-select w-auto">
                      <SelectBox v-model="$v.corporateFeatureInfo.$model.accountClosingMonth"
                        :options="monthList"
                        :selectedValue="this.corporateFeatureInfo.accountClosingMonth"></SelectBox>
                    </div>
                  </td>
                </tr>
                <!-- 主たる業種 -->
                <tr>
                  <th><span>主たる業種</span></th>
                  <td>
                    <div class="l-select w-auto">
                      <SelectBox
                        v-model="$v.corporateFeatureInfo.$model.industoryItemId"
                        :options="industoryItemArray"
                        :selectedValue="this.corporateFeatureInfo.industoryItemId"
                        @input="IndustoryItemChange"></SelectBox>
                    </div>
                    <div class="l-select w-auto">
                      <SelectBox
                        v-model="$v.corporateFeatureInfo.$model.industorySubitemId"
                        :disabled="this.industorySubitemDisabled"
                        :options="industorySubitemArray"
                        :selectedValue="this.corporateFeatureInfo.industorySubitemId"></SelectBox>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="u-tac u-mt30"><div class="btn-basic is-inlne is-primary"><button @click="saveCorpSettings">保存</button></div></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 設定保存の画面(一般ユーザー) -->
    <div class="l-contents" v-if="showSetting && isNormal">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav8_blue.svg" alt="">人的資本管理</h1>
      <div class="l-contentsBox">
        <div class="human-capital-welcome">
          <div class="human-capital-welcome__img"><img src="@/assets/img/common/hc-icon01.svg" alt=""></div>
          <p class="human-capital-welcome__catch">ヨクスルの人的資本管理へようこそ</p>
          <div class="human-capital-welcome__body">
            <p class="l-text u-tac is-lg"><strong>人的資本を利用するために必須の情報を入力してください。</strong></p>
            <p class="l-text u-tac u-mt30">人的資本を利用するためには下記の項目の設定が必要です。</p>
            <ul class="human-capital-welcome__list">
              <li>決算月</li>
              <li>主たる業種</li>
            </ul>
            <p class="l-text u-tac">管理権限を持った社労士にご相談ください。</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 通常コンテンツ -->
    <div v-if="!showCreate && !showSetting">

      <div class="alert-box" v-if="!this.hasCurrentYearAchievementData">
        <p>昨年度の実績を把握するために年度を追加しませんか？</p>
        <div class="btn-create-new_wh" @click="addYear"><a class="js-add-year-modal-show">年度を追加する</a></div>
      </div>
      <h2 class="heading-lv2">{{this.dispYear}}年{{this.accountMonth}}月期の実績</h2>
      <div class="btn-group is-left u-mb20">
        <div class="btn-basic is-middle is-noarrow"><a @click="goSummary()"><img src="@/assets/img/common/icon-graph.svg" alt="" class="btn-icon">過去５年の推移を見る</a></div>
      </div>

      <div class="financial-data u-mb40">
        <div class="financial-data-body">
          <p class="financial-data__title">
            <img src="@/assets/img/common/icon-financial.svg" alt="">
            財務情報
          </p>
          <p class="financial-data__text">売上高：<strong><Currency :value="achievements['achievement_sales']"/></strong>千円</p>
          <p class="financial-data__text">粗利：<strong><Currency :value="achievements['achievement_gross_profit']"/></strong>千円</p>
          <p class="financial-data__text">経常利益：<strong><Currency :value="achievements['achievement_ordinary_profit']"/></strong>千円</p>
        </div>
        <div class="financial-data-link">
          <a @click="goPages(14, 'input')" class="link-arrow is-edit-link">編集</a>
          <a @click="goPages(14, 'report')" class="link-arrow is-report-link">レポート</a>
        </div>
      </div>

      <p class="l-text u-tar u-mb10">（）は業界平均値</p>
      <div class="human-capital-graphic">

        <div class="human-capital-graphic__item is-harf human-capital-graphic__item1">
          <div class="human-capital-graphic__header">
            <p>採用</p>
            <div><img src="@/assets/img/common/hc-icon01.svg" alt=""></div>
          </div>
          <div class="human-capital-graphic__body">
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>採用女性労働者割合</span>
                <span class="icon-help" data-tooltip='採用した労働者に占める女性労働者の割合/直近の事業年度の女性の採用者数（中途採用含む）÷直近の事業年度の採用者数（中途採用含む）×100（％）'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data">
                <p>
                  <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_female_percentage']"/></span>
                  <span class="human-capital-graphic-data__unit">%</span>
                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['femalePercentage']" :unit="unitPer"/>）</span>
                </p>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(1, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(1, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>
          </div>
        </div><!--/human-capital-graphic__item-->

        <div class="human-capital-graphic__item is-harf human-capital-graphic__item2">
          <div class="human-capital-graphic__header">
            <p>定着</p>
            <div><img src="@/assets/img/common/hc-icon02.svg" alt=""></div>
          </div>
          <div class="human-capital-graphic__body">
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>平均継続勤務年数</span>
                <span class="icon-help" data-tooltip='直近の事業年度（期末時点）における平均継続勤務年数（年換算　小数点1桁）'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data">
                <p class="u-mb10">
                  <span class="human-capital-graphic-data__label">男性</span>
                  <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_male_employment_year']"/></span>
                  <span class="human-capital-graphic-data__unit">年</span>
                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['employmentYearsAveMale']" :unit="unitYear"/>）</span>
                </p>
                <p>
                  <span class="human-capital-graphic-data__label">女性</span>
                  <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_female_employment_year']"/></span>
                  <span class="human-capital-graphic-data__unit">年</span>
                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['employmentYearsAveFemale']" :unit="unitYear"/>）</span>
                </p>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(2, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(2, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>

            <div class="human-capital-graphic-block-separate"></div>

            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>離職率</span>
                <span class="icon-help" data-tooltip='離職者数÷1月1日現在の労働者数×100（％）'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data">
                <p class="u-mb10">
                  <span class="human-capital-graphic-data__label">男性</span>
                  <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_male_turnover']"/></span>
                  <span class="human-capital-graphic-data__unit">%</span>
                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['turnoverMale']" :unit="unitPer"/>）</span>
                </p>
                <p>
                  <span class="human-capital-graphic-data__label">女性</span>
                  <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_female_turnover']"/></span>
                  <span class="human-capital-graphic-data__unit">%</span>
                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['turnoverFemale']" :unit="unitPer"/>）</span>
                </p>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(3, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(3, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>
          </div>
        </div><!--/human-capital-graphic__item-->

        <div class="human-capital-graphic__item human-capital-graphic__item3">
          <div class="human-capital-graphic__header">
            <p>人員構成</p>
            <div><img src="@/assets/img/common/hc-icon03.svg" alt=""></div>
          </div>
          <div class="human-capital-graphic__body">
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>女性管理職比率</span>
                <span class="icon-help" data-tooltip='女性の管理職数÷管理職数×100（％）'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data">
                <p>
                  <span class="human-capital-graphic-data__number"><Currency :value="achievements['achievement_female_manager_ratio']"/></span>
                  <span class="human-capital-graphic-data__unit">%</span>
                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['femaleManagersRatio']" :unit="unitPer"/>）</span>
                </p>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(4, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(4, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>
            <div class="human-capital-graphic-block-separate"></div>
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>平均年齢</span>
                <span class="icon-help" data-tooltip='直近の事業年度の1月1日現在の満年齢の平均'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data-group">
                <div class="human-capital-graphic-data">
                  <p>
                    <span class="human-capital-graphic-data__label">男性</span>
                    <span class="human-capital-graphic-data__number"><Currency :value="achievements['achievement_male_age_average']"/></span>
                    <span class="human-capital-graphic-data__unit">歳</span>
                    <span class="human-capital-graphic-data__target">（<Currency :value="averages['ageAveMale']" :unit="unitAge"/>）</span>
                  </p>
                </div>
                <div class="human-capital-graphic-data">
                  <p>
                    <span class="human-capital-graphic-data__label">女性</span>
                    <span class="human-capital-graphic-data__number"><Currency :value="achievements['achievement_female_age_average']"/></span>
                    <span class="human-capital-graphic-data__unit">歳</span>
                    <span class="human-capital-graphic-data__target">（<Currency :value="averages['ageAveFemale']" :unit="unitAge"/>）</span>
                  </p>
                </div>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(5, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(5, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>
            <div class="human-capital-graphic-block-separate"></div>
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>障がい者雇用率</span>
                <span class="icon-help" data-tooltip='それぞれの事業年度における「障害者雇用状況報告書」を元にした障害者雇用率'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data">
                <p>
                  <span class="human-capital-graphic-data__number"><Currency :value="achievements['achievement_disabilities_rate']"/></span>
                  <span class="human-capital-graphic-data__unit">%</span>
<!--                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['disabilitiesRate']" :unit="unitPer"/>）</span>-->
                </p>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(6, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(6, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>
            <div class="human-capital-graphic-block-separate"></div>
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>高年齢者雇用率</span>
                <span class="icon-help" data-tooltip='それぞれの事業年度における「高年齢者雇用状況報告書」を元にした高年齢者雇用率'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data">
                <p>
                  <span class="human-capital-graphic-data__number"><Currency :value="achievements['achievement_elderly_rate']"/></span>
                  <span class="human-capital-graphic-data__unit">%</span>
<!--                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['elderlyRate']" :unit="unitPer"/>）</span>-->
                </p>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(7, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(7, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>
          </div>
        </div><!--/human-capital-graphic__item-->

        <div class="human-capital-graphic__item is-harf human-capital-graphic__item4">
          <div class="human-capital-graphic__header">
            <p>安全衛生</p>
            <div><img src="@/assets/img/common/hc-icon05.svg" alt=""></div>
          </div>
          <div class="human-capital-graphic__body">
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>労災発生件数</span>
                <span class="icon-help" data-tooltip='休業3日以内＝療養のみ及び休業3日以内（障害・死亡を除く）の労災発生件数<br>休業4日以上＝休業4日以上及び障害・死亡に至った労災発生件数'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data">
                <p>
                  <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_accidents_count']"/></span>
                  <span class="human-capital-graphic-data__unit">件</span>
<!--                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['accidentsCount']" :unit="unitCount"/>）</span>-->
                </p>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(8, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(8, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>
          </div>
        </div><!--/human-capital-graphic__item-->

        <div class="human-capital-graphic__item is-harf human-capital-graphic__item5">
          <div class="human-capital-graphic__header">
            <p>労働条件</p>
            <div><img src="@/assets/img/common/hc-icon06.svg" alt=""></div>
          </div>
            <div class="human-capital-graphic__body is-top">
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>年次有給休暇取得率</span>
                <span class="icon-help" data-tooltip='年次有給休暇の取得率＝直近年度における「労働者が取得した有給休暇（労働基準法第39条）の日数」÷「労働者に与えられた有給休暇の日数」×100'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data">
                <p class="u-mb10">
                  <span class="human-capital-graphic-data__label">正社員　　</span>
                  <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_regular_annual_acquisition_rate']"/></span>
                  <span class="human-capital-graphic-data__unit">%</span>
                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['annualAcquisitionRateReguler']" :unit="unitPer"/>）</span>
                </p>
                <p>
                  <span class="human-capital-graphic-data__label">非正規社員</span>
                  <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_non_regular_annual_acquisition_rate']"/></span>
                  <span class="human-capital-graphic-data__unit">%</span>
                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['annualAcquisitionRateNotReguler']" :unit="unitPer"/>）</span>
                  </p>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(9, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(9, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>

            <div class="human-capital-graphic-block-separate"></div>

            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title is-middle">
                <span>1月あたりの平均残業時間</span>
                <span class="icon-help" data-tooltip='直近の事業年度における「各月の対象労働者（全ての労働者）の（法定時間外労働＋法定休日労働）の総時間数の合計」÷「対象労働者数」<br>これにより難い場合は [「各月の対象労働者（全ての労働者）の総労働時間数の合計」―「各月の法定労働時間の合計＝(40×各月の日数÷7)×対象労働者数」]÷「対象労働者数」'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data">
                <p class="u-mb10">
                  <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_working_hours_average']"/></span>
                  <span class="human-capital-graphic-data__unit">時間</span>
                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['overtimeAve']" :unit="unitHour"/>）</span>
                </p>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(10, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(10, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>
          </div>
        </div><!--/human-capital-graphic__item-->

        <div class="human-capital-graphic__item human-capital-graphic__item6">
          <div class="human-capital-graphic__header">
            <p>育児介護休業</p>
            <div><img src="@/assets/img/common/hc-icon07.svg" alt=""></div>
          </div>
          <div class="human-capital-graphic__body">
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>育児休業取得率</span>
                <span class="icon-help" data-tooltip='男性の取得率＝男性労働者のうち育児休業をした数÷男性労働者のうち配偶者が出産した数×100（％）<br>女性の取得率＝女性労働者のうち育児休業をした数÷女性労働者のうち出産した数×100（％）'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data-group">
                <div class="human-capital-graphic-data">
                  <p>
                    <span class="human-capital-graphic-data__label">男性</span>
                    <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_male_childcare_rate']"/></span>
                    <span class="human-capital-graphic-data__unit">%</span>
                    <span class="human-capital-graphic-data__target">（<Currency :value="averages['childcareRateMale']" :unit="unitPer"/>）</span>
                  </p>
                </div>
                <div class="human-capital-graphic-data">
                  <p>
                    <span class="human-capital-graphic-data__label">女性</span>
                    <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_female_childcare_rate']"/></span>
                    <span class="human-capital-graphic-data__unit">%</span>
                    <span class="human-capital-graphic-data__target">（<Currency :value="averages['childcareRateFemale']" :unit="unitPer"/>）</span>
                  </p>
                </div>
                <div class="human-capital-graphic-data">
                  <p>
                    <span class="human-capital-graphic-data__label">全体</span>
                    <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_all_childcare_rate']"/></span>
                    <span class="human-capital-graphic-data__unit">%</span>
                    <span class="human-capital-graphic-data__target">（<Currency :value="averages['childcareRateCorp']" :unit="unitPer"/>）</span>
                  </p>
                </div>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(11, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(11, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>
            <div class="human-capital-graphic-block-separate"></div>
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title is-long">
                <span>介護休業・短時間勤務取得者数</span>
                <span class="icon-help" data-tooltip='それぞれの事業年度における介護休業の取得者数と介護短時間勤務取得者数'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data">
                <p>
                  <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_nursing_care_leave']"/></span>
                  <span class="human-capital-graphic-data__unit">名</span>
<!--                  <span class="human-capital-graphic-data__target">（<Currency :value="averages['nursingCareLeave']" :unit="unitPerson"/>）</span>-->
                </p>
              </div>
                <div class="human-capital-graphic-data__link">
                  <a @click="goPages(12, 'input')" class="link-arrow is-edit-link">編集</a>
                  <a @click="goPages(12, 'report')" class="link-arrow is-report-link">レポート</a>
                </div>
            </div>
          </div>
        </div><!--/human-capital-graphic__item-->

        <div class="human-capital-graphic__item human-capital-graphic__item7">
          <div class="human-capital-graphic__header">
            <p>賃金</p>
            <div><img src="@/assets/img/common/hc-icon08.svg" alt=""></div>
          </div>
          <div class="human-capital-graphic__body">
            <div class="human-capital-graphic-block">
              <p class="human-capital-graphic__title">
                <span>年間平均賃金</span>
                <span class="icon-help" data-tooltip='賃金差異＝女性の年間平均賃金÷男性の年間平均賃金×100（％）'>
                  <img src="@/assets/img/common/icon-help-white.svg" alt="" width="16px">
                </span>
              </p>
              <div class="human-capital-graphic-data-group">
                <div class="human-capital-graphic-data">
                  <p>
                    <span class="human-capital-graphic-data__label">男性</span>
                    <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_wage_ave_male']"/></span>
                    <span class="human-capital-graphic-data__unit">千円</span>
                    <span class="human-capital-graphic-data__target">（<Currency :value="averages['wageAveMale']" :unit="unitMoney"/>）</span>
                  </p>
                </div>
                <div class="human-capital-graphic-data">
                  <p>
                    <span class="human-capital-graphic-data__label">女性</span>
                    <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_wage_ave_female']"/></span>
                    <span class="human-capital-graphic-data__unit">千円</span>
                    <span class="human-capital-graphic-data__target">（<Currency :value="averages['wageAveFemale']" :unit="unitMoney"/>）</span>
                  </p>
                </div>
                <div class="human-capital-graphic-data">
                  <p>
                    <span class="human-capital-graphic-data__label">賃金差異</span>
                    <span class="human-capital-graphic-data__number"><Currency :value="this.achievements['achievement_wage_ave_diff']"/></span>
                    <span class="human-capital-graphic-data__unit">%</span>
                    <span class="human-capital-graphic-data__target">（<Currency :value="averages['wageAveDiff']" :unit="unitPer"/>）</span>
                  </p>
                </div>
              </div>
              <div class="human-capital-graphic-data__link">
                <a @click="goPages(13, 'input')" class="link-arrow is-edit-link">編集</a>
                <a @click="goPages(13, 'report')" class="link-arrow is-report-link">レポート</a>
              </div>
            </div>
          </div>
        </div><!--/human-capital-graphic__item-->
      </div>
    </div>
  </div>

</template>

<script>

import Currency from '@/components/parts/human_capital/parts/Currency.vue';
import constant from '@/const';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import SelectBox from '@/components/parts/form/SelectBox.vue';
import { required } from 'vuelidate/lib/validators';

export default {
  components: {
    Currency,
    ValidationErrorMessage,
    SelectBox,
  },
  props: {
    corpId: {},
    startYear: {},
  },
  data() {
    return {
      lineChartData: {
        labels: [],
        datasets: [],
      },
      lineChartOptions: {},

      accountMonth: null,
      dispYear: null,
      achievements: [],
      averages: [],
      unitCount: "件",
      unitPer: "％",
      unitYear: "年",
      unitAge: "歳",
      unitPerson: "名",
      unitMoney: "千円",
      unitHour: "時間",

      transitionList: constant.TRANSITION_LIST,

      showCreate: false,
      showSetting: false,
      addYearAlert: false,

      isSystemAdmin: false,
      isAllPermission: false,
      isAdmin: false,
      isNormal: false,

      hasCurrentYearAchievementData: false,
      currentYear: null,

      corporateFeatureInfo: {},
      monthList: constant.MONTH_LIST,
      industoryItemArray: constant.INDUSTORY_ITEM,
      industorySubitemArray: [],
      industorySubitemDisabled: true,

    }
  },
  validations: {
    corporateFeatureInfo: {
      accountClosingMonth: {required},
      industoryItemId: {required},              // 業種大項目
      industorySubitemId: {required},           // 業種中項目
    }
  },
  created: async function() {
    this.isRendering = true;
    this.isProcessing = true;

    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isSystemAdmin = authority.isSystemAdmin;
    this.isAllPermission = authority.isAllPermission;
    this.isAdmin = authority.isAdmin;
    this.isNormal = authority.userAuthNo==9;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

    // 人的資本データの取得
    let res = await this.$axios.post('/ld/api/hr/getHumanCapitalListData', { corpId: this.corpId });
    if (res.status == 200) {
      if ( res.data.status == 0 ) {
        this.achievements = res.data.inputForm.achievements;
        this.averages = res.data.inputForm.averages;
        this.accountMonth = res.data.inputForm.accountMonth;
        this.currentYear = res.data.inputForm.currentYear;
        this.dispYear = res.data.inputForm.dispYear;
        this.hasCurrentYearAchievementData = res.data.inputForm.hasCurrentYearAchievementData;
        this.showSetting = false;
        this.showCreate = false;
      }else if ( res.data.status == -1 ) {
        // 決算月もしくは業種が登録されていない
        this.showCreate = false;
        this.showSetting = true;
        this.corporateFeatureInfo = res.data.corporateFeatureInfo;
        this.IndustoryItemChange();
      }else if ( res.data.status == -2 ) {
        // 決算月もしくは業種が登録されているが、データがない
        this.showSetting = false;
        this.showCreate = true;
        this.currentYear = res.data.currentYear;
      }else {
        // error
      }
    }

    this.isRendering = false;
    this.isProcessing = false;
  },
  methods: {
    goCorp() {
      this.$router.push({ name: 'corporate-edit', query: { corpId: this.corpId } });
    },
    // 遷移関数
    goPages(num, type) {
      this.$router.replace({path: '/hr/'+this.corpId + '/' + this.transitionList[num] + '_' + type});
    },
    // 遷移関数
    goSummary() {
      this.$router.replace({path: '/hr/'+this.corpId + '/summary_graph'});
    },
    async changeCorpId(corpId) {

      this.isRendering = true;
      this.isProcessing = true;

      const authority = await this.$store.dispatch('auth/getAuthority')
      this.isSystemAdmin = authority.isSystemAdmin;
      this.isAllPermission = authority.isAllPermission;
      this.isAdmin = authority.isAdmin;
      this.isNormal = authority.userAuthNo==9;
      this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

      // 人的資本データの取得
      let res = await this.$axios.post('/ld/api/hr/getHumanCapitalListData', { corpId: corpId });
      if (res.status == 200) {
        if ( res.data.status == 0 ) {
          this.achievements = res.data.inputForm.achievements;
          this.averages = res.data.inputForm.averages;
          this.accountMonth = res.data.inputForm.accountMonth;
          this.currentYear = res.data.inputForm.currentYear;
          this.dispYear = res.data.inputForm.dispYear;
          this.hasCurrentYearAchievementData = res.data.inputForm.hasCurrentYearAchievementData;
          this.showSetting = false;
          this.showCreate = false;
        }else if ( res.data.status == -1 ) {
          // 決算月もしくは業種が登録されていない
          this.showCreate = false;
          this.showSetting = true;
          this.corporateFeatureInfo = res.data.corporateFeatureInfo;
          this.IndustoryItemChange();
        }else if ( res.data.status == -2 ) {
          // 決算月もしくは業種が登録されているが、データがない
          this.showSetting = false;
          this.showCreate = true;
          this.currentYear = res.data.currentYear;
        }else {
          // error
        }
      }
      this.isRendering = false;
      this.isProcessing = false;
    },
    /**
     * 年度追加処理
     */
    async createNewYear() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/hr/createNewYear', { corpId: this.corpId, year: this.currentYear });
      if ( res.status == 200 ) {
          this.$toast.info('登録が完了しました');

      this.$router.replace({path: '/hr/'+this.corpId + '/topparam'});

/*
        // 人的資本データの取得
        let res = await this.$axios.post('/ld/api/hr/getHumanCapitalListData', { corpId: this.corpId });
        if (res.status === 200) {
          this.achievements = res.data.inputForm.achievements;
          this.averages = res.data.inputForm.averages;
          this.accountMonth = res.data.inputForm.accountMonth;
          this.currentYear = res.data.inputForm.currentYear;
          this.dispYear = res.data.inputForm.dispYear;
          this.hasCurrentYearAchievementData = res.data.inputForm.hasCurrentYearAchievementData;
          this.showCreate = false;
        } else {
          this.$toast.error(res.data.message);
        }*/
      } else {
        this.$toast.error(res.data.message);
      }
      // モーダル画面を閉じる
      this.closeAddYearAlert();
      this.isProcessing = false;
    },
    closeAddYearAlert() {
      this.addYearAlert = false;
    },
    addYear() {
      this.addYearAlert = true;
      this.$emit("click-add-year", {
        addYearAlert: this.addYearAlert,
        accountMonth: this.accountMonth,
        currentYear : this.currentYear,
      });
    },
    // セレクトボックスの値に応じてサブセレクトボックスを更新
    IndustoryItemChange() {
      if (this.corporateFeatureInfo.industoryItemId != null) {
        let itemId =String(this.corporateFeatureInfo.industoryItemId);
        if ( itemId.length > 0 && itemId != '') {
          this.industorySubitemArray = constant.INDUSTORY_SUBITEM[this.corporateFeatureInfo.industoryItemId]['options'];
          this.industorySubitemDisabled = false;
        }else{
          this.industorySubitemArray = [];
          this.corporateFeatureInfo.industorySubitemId = null;
          this.industorySubitemDisabled = true;
        }
      }else{
          this.industorySubitemArray = [];
          this.corporateFeatureInfo.industorySubitemId = null;
          this.industorySubitemDisabled = true;
      }
    },
    async saveCorpSettings() {
      this.$v.$touch();
      if (!this.$v.$invalid){

        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/hr/saveCorpSettings', {
          corpId: this.corpId,
          industoryItemId: this.corporateFeatureInfo.industoryItemId,
          industorySubitemId: this.corporateFeatureInfo.industorySubitemId,
          accountClosingMonth: this.corporateFeatureInfo.accountClosingMonth
        });
        if (res.status === 200) {
          this.$toast.info('法人情報の登録が完了しました');
          this.currentYear = res.data.currentYear;

          this.$emit("save-corp-setting", {
            message: true,
          });

          this.showSetting = false;
          this.showCreate = true;
        } else {
          this.$toast.error('エラーが発生しました。');
        }
        this.isProcessing = false;
      }
    }

  },
}
</script>

<style scoped>
.chart-area {
  border: 2px solid rgba(220, 220, 220, 0.5);
  border-radius: 10px;
  padding: 10px;
  background-color: rgba(248, 248, 255, 0.5);
}
</style>